import { useState, useLayoutEffect } from "react"
import {
    useLoaderData,
    useLocation,
    useNavigate,
    useOutletContext,
} from "react-router-dom"

import axios from "axios"
import { useAuth } from "contexts/auth-context"
import Form from "./form"
import nProgress from "nprogress"
import toast from "react-hot-toast"
import { useSWRConfig } from "swr"
import { usePage } from "contexts/page-context"
import { Transition } from "components"
import moment from "moment"
import { useAuditLogContext } from "contexts/audit-log-context"

export default function Edit() {
    const { user } = useAuth()
    const { cache } = useSWRConfig()

    const { queueAuditLog } = useAuditLogContext()
    const { setTransition } = usePage()
    const { setTitle } = useOutletContext()

    const loaderData = useLoaderData() // data detail products_supplier

    const location = useLocation()
    const navigate = useNavigate()

    const [prevRouteState, setPrevRouteState] = useState({})
    const [errors, setErrors] = useState({})

    useLayoutEffect(() => {
        const getPrevRouteState = async () => {
            setPrevRouteState({
                back: location.state?.back,
                from: location.state?.from,
                transition: location.state?.transition,
            })
        }

        setTransition(location.state?.transition)
        // judul bisa pakai kombinasi model & supplier (kalau loaderData sudah include relasi)
        setTitle(`Edit Product Supplier ${loaderData?.id}`)

        getPrevRouteState()
    }, [])

    const handleSubmit = (data) => {
        nProgress.start()

        toast.loading("Loading", {
            id: "submit",
        })

        const url = `${process.env.REACT_APP_INVENTORY_API_URL}/product/supplier/${data?.id}`

        const payload = {
        product_model_ids: data.product_model_ids,
        }

        axios
            .patch(url, payload)
            .then((response) => {

                // Clear SWR cache
                cache.clear()

                // Navigate page
                navigate({ pathname: "/product/supplier" })

                // Show toast message
                toast.success(response.data.message, {
                    id: "submit",
                })
            })
            .catch((error) => {
                // Assign validation message
                if (error.response?.status === 422) {
                    setErrors(error.response.data.errors ?? {})
                }

                // Show toast message
                toast.error(error.response?.data?.message ?? "Failed", {
                    ariaProps: {
                        superscript: error.response?.status,
                    },
                    id: "submit",
                })
            })
    }

    return (
        <Transition type="slide" reversed={true}>
            <Form data={loaderData} errors={errors} onSubmit={handleSubmit} />
        </Transition>
    )
}
